import { IdNamePair } from "./utils";

export type RelatedClaimType = "contract" | "insuredgood";

export enum BrokerState {
    ALL = "0",
    CLOSED = "1",
    ON_GOING = "3",
}

export interface ClaimPagination extends Omit<MyBrokerApi.ClaimV2Payload, "result"> {
    result: Claim[];
}

export type ClaimSortProperty = Paths.ApiClaim.Get.Parameters.SortProperty;

export interface Claim extends MyBrokerApi.ClaimV2 {
    key: string;
}

export interface SearchableClaim extends Omit<Claim, "damageEventDate" | "reference"> {
    damageEventDateString?: string;
    referenceString?: string;
}

export interface RelatedClaimPagination extends Omit<MyBrokerApi.RelatedClaimPayload, "result"> {
    result: RelatedClaim[];
}

export interface RelatedClaim extends MyBrokerApi.RelatedClaim {
    damageEventDate?: Date;
    brokerState?: IdNamePair;
    policyholderId: number;
    circumstance: IdNamePair;
}

export const defaultRelatedClaimPagination = { result: [] as RelatedClaim[], total: 0 };
